import type { Move } from '../../../schemas/move';
import { magoArchetypeMoves } from './archetypes';
import { magoInitialMoves, magoStartingAutoMoves, magoStartingChoiceMoves } from './initial';
import { magoAdvanced2to5Moves } from './advanced-2-5';
import { magoAdvanced6to10Moves } from './advanced-6-10';

export {
  magoArchetypeMoves,
  magoInitialMoves,
  magoStartingAutoMoves,
  magoStartingChoiceMoves,
  magoAdvanced2to5Moves,
  magoAdvanced6to10Moves,
};

/**
 * Catalogo completo delle mosse del Mago (manuale V1, sezione "Il Mago",
 * rr. 4000-4394).
 *
 * Aggregato di:
 *  - 5 archetipi (`class_special`)
 *  - 4 mosse iniziali automatiche + 2 mosse iniziali di scelta (`starting`,
 *    `pickCount: 1` sul gruppo di scelta)
 *  - 16 mosse avanzate L2-5 (`advanced_2_5`)
 *  - 14 mosse avanzate L6-10 (`advanced_6_10`)
 *
 * Totale: 41 mosse.
 *
 * **Pattern stress-testati per la prima volta in questa classe**:
 *  - `SpellcastingConfig` popolato (mai usato prima nel data-entry)
 *  - `MoveSchema.replaces` con uso reale (Magia Potenziata Superiore →
 *    Magia Potenziata; Estremamente Logico → Logico)
 */
export const magoMoves: readonly Move[] = [
  ...magoArchetypeMoves,
  ...magoInitialMoves,
  ...magoAdvanced2to5Moves,
  ...magoAdvanced6to10Moves,
];
